import CartItemExpansion from './CartItemExpansion';

export default CartItemExpansion;
